import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { purchaseProduct, ERROR_ALREADY_PREMIUM } from '../../payments'
import { useSelector } from 'react-redux'
import { selectCoupon, selectPricingConfig } from '../../store/pricingSlice'
import { setItem } from '../../storeManager'
import Box from './Box'
import { FormattedMessage } from 'react-intl'
import { selectId, selectLimitedProfile } from '../../store/userSlice'
import useLocale from '../../hooks/useLocale'
import { createSelector } from '@reduxjs/toolkit'

const selectUserId = createSelector(
  [selectId, selectLimitedProfile],
  (id, limitedProfile) => id || limitedProfile?.id,
)

const SignUpFreePurchase = () => {
  const { currency } = useLocale()
  const pricingConfig = useSelector(selectPricingConfig())
  const coupon = useSelector(selectCoupon)
  const navigate = useNavigate()
  const userId = useSelector(selectUserId)
  const [alreadyPremium, setAlreadyPremium] = useState(false)
  const [error, setError] = useState(false)

  const paymentData = {
    user_id: userId,
    product: {
      type: 'subscription',
      options: {
        duration: pricingConfig.products[0].duration,
        currency: currency,
        coupon_code: coupon,
      },
    },
  }

  useEffect(() => {
    if (!userId) {
      return
    }

    purchaseProduct(paymentData)
      .then(() => {
        setItem(
          'paymentState',
          JSON.stringify({
            paymentData: paymentData,
            scenario: '100-percent-discount',
          }),
        )
        navigate('/finalize-payment')
      })
      .catch((error) => {
        if (error === ERROR_ALREADY_PREMIUM) {
          setAlreadyPremium(true)
        } else {
          setError(true)
        }
      })
    // FIXME: dont ignore
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  return (
    <div className="o-width-limiter">
      <Box>
        {alreadyPremium ? (
          <p className="text-green type-20-bold">
            <FormattedMessage
              id="InfluencerRedeemPage.alreadyPremium"
              defaultMessage="This account already has Lifesum Premium 😀"
            />
          </p>
        ) : error ? (
          <div className="s-text text-secondary-red">
            <p className="font-bold">
              <FormattedMessage
                id="Redeem.pay.didntGoAsPlanned"
                defaultMessage="Something didn’t go as planned"
              />
            </p>
            <p>
              <FormattedMessage
                id="Redeem.pay.contactCustomerSupport"
                defaultMessage="If you need any help, please contact support at <a>https://lifesum.com/contact</a>"
                values={{
                  a: function Link(...chunks) {
                    return <a href="https://lifesum.com/contact">{chunks}</a>
                  },
                }}
              />
            </p>
          </div>
        ) : (
          <div className="c-signup-flow__setup">
            <div className="c-signup-flow__setup-spinner">
              <img src={require('media/spinner.gif')} alt="" />
            </div>
          </div>
        )}
      </Box>
    </div>
  )
}

export default SignUpFreePurchase
